import ThreeByOnePodcastInfo, {
  ThreeByOnePodcastInfoProps,
} from './ThreeByOnePodcastInfo';

export default ThreeByOnePodcastInfo;
export type { ThreeByOnePodcastInfoProps };
